var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletePasswordPolicyAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 2.5H2.08333H8.75",
    stroke: "#4B475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91659 2.50016V8.3335C7.91659 8.55451 7.82879 8.76647 7.67251 8.92275C7.51623 9.07903 7.30427 9.16683 7.08325 9.16683H2.91659C2.69557 9.16683 2.48361 9.07903 2.32733 8.92275C2.17105 8.76647 2.08325 8.55451 2.08325 8.3335V2.50016M3.33325 2.50016V1.66683C3.33325 1.44582 3.42105 1.23385 3.57733 1.07757C3.73361 0.921293 3.94557 0.833496 4.16659 0.833496H5.83325C6.05427 0.833496 6.26623 0.921293 6.42251 1.07757C6.57879 1.23385 6.66659 1.44582 6.66659 1.66683V2.50016",
    stroke: "#4B475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 4.5835V7.0835",
    stroke: "#4B475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 4.5835V7.0835",
    stroke: "#4B475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_2257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePasswordPolicyAction);
export default __webpack_public_path__ + "static/media/delete_password_policy_action.0446e011b5896f4f22c85425fb41e0dc.svg";
export { ForwardRef as ReactComponent };